import { inject, Injectable } from '@angular/core';
import type { Route } from '@angular/router';
import { UserService } from './user.service';

@Injectable()
export class RolesAuthGuardService {
  private userService = inject(UserService);

  canLoad(route: Route): boolean {
    if (
      this.userService.isMEGAUser &&
      (route.path === 'mega-trade' || route.path === 'remic-shelf')
    ) {
      return true;
    }

    if (this.userService.isRCRUser && route.path === 'rcr-exchange') {
      return true;
    }
  }
}
